import React, { FC, useLayoutEffect } from 'react';
import { FLGrayStacked } from '@lifeomic/phc-web-toolkit/src/components/Logos';
import { dismissHtmlAppLoader } from './dismissHtmlAppLoader';

export const APP_LOADER_CLASS = 'phc-app-loader';
export const APP_LOADER_CARD_CLASS = 'phc-app-loader__card';
export const APP_LOADER_LOGO_CLASS = 'phc-app-loader__logo';
export const APP_LOADER_MESSAGE_CLASS = 'phc-app-loader__message';
export const APP_LOADER_PROGRESS_CLASS = 'phc-app-loader__progress';
export const APP_LOADER_PROGRESS_BAR_CLASS = 'phc-app-loader__progress-bar';

interface Props {
  text?: string;
}

const LoadingViewComponent: FC<Props> = ({ text }: Props) => {
  useLayoutEffect(() => {
    dismissHtmlAppLoader();
  }, []);

  return (
    <div className={APP_LOADER_CLASS}>
      <div className={APP_LOADER_CARD_CLASS}>
        <FLGrayStacked className={APP_LOADER_LOGO_CLASS} aria-hidden />
        {text ? <p className={APP_LOADER_MESSAGE_CLASS}>{text}</p> : null}
        <div
          className={APP_LOADER_PROGRESS_CLASS}
          role="progressbar"
          aria-label="Loading"
        >
          <div className={APP_LOADER_PROGRESS_BAR_CLASS} />
        </div>
      </div>
    </div>
  );
};

LoadingViewComponent.displayName = 'LoadingViewComponent';
export default LoadingViewComponent;
